import $ from 'jquery';
import axios from 'axios';
import { throttle } from 'lodash';

import { getAllFocusableElementsWithinElement  } from './helper';

let storyMouseDown = false;
let storyMouseStartX;
let storyMouseScrollLeft;
const scrollSpeed = 700;
// let movingTimeout = -1;
let direction;

let arrowKeydownTimestamp = null;
let arrowKeydownPreviousTimestamp = null;
let isArrowKeyDown = false;
let rafTicking = false;
let storyWrapperElem = null;
let storyModalElem = null;
let isMobile = null;

let enterKeyPressed = false;

// When the window has loaded, run the initalisation code for stories modals
const storiesInit = () => {
    // Detect whether or not the story is being shown in the detail mode
    const url = window.location.href;

    if (url.includes('storyId')) {
        resetScrollContainerVisibility();
        
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        loadStoryModal(window.preferredCulture, params.storyId);
    }

    initaliseModalEventListeners();

    if (storyDetailPageActive()) {
        storyProgressInit();
        calculateStoryProgress();
    }
}

const storyDetailPageActive = () => {
    return document.querySelector('.stories__wrapper--detail');
}

const resetScrollContainerVisibility = () => {
    const scrollContainer = $('#scroll-container').children();

    if (scrollContainer) {
        scrollContainer.each(index => {
            scrollContainer[index].classList.add("visibility-none")
        })
    }
}

const extractStoriesParamsFromURL = (url) => {
    const queryStringParams = url.split('/').pop();
    const urlSearchParams = new URLSearchParams(queryStringParams);
    const params = Object.fromEntries(urlSearchParams.entries());

    return { params };
}

export {
    storiesInit,
}

const storyProgressInit = function () {
    isMobile = checkScreensize();
    storyWrapperElem = document.querySelector('.stories__wrapper');
    storyModalElem = document.querySelector('.story__modal');

    document.querySelector('.stories__wrapper').addEventListener('scroll', throttle(calculateStoryProgress, 100));
    
    if (!isMobile) {
        window.addEventListener('wheel', throttle(scrollStory, 5));
        document.querySelector('.stories__wrapper').addEventListener('mousemove', dragging, false);
        document.querySelector('.stories__wrapper').addEventListener('mousedown', startDragging, false);
        document.querySelector('.stories__wrapper').addEventListener('mouseup', stopDragging, false);
        document.addEventListener('keydown', keyDownScrollingEvent);
        document.addEventListener('keyup', keyUpScrollingEvent);
    }

    $(".stories__wrapper").on("touchmove", throttle(calculateStoryProgress, 100));;
}

const keyDownScrollingEvent = function (event) {
    // event.preventDefault(); 

    if (isArrowKeyDown === false && event.code === 'ArrowLeft') {
        direction = 'left';
        isArrowKeyDown = true;
    } else if (isArrowKeyDown === false && event.code === 'ArrowRight') {
        direction = 'right';
        isArrowKeyDown = true;
    }

    if (isArrowKeyDown) {
        storyWrapperElem.style.scrollBehavior = 'auto';
        requestArrowTick();
    }
}

const requestArrowTick = function () {
    if (rafTicking === false) {
        window.requestAnimationFrame(arrowKeyMovement)
        rafTicking = true;
    }
}

const keyUpScrollingEvent = function (event) {
    if (event.code === 'ArrowLeft' || event.code === 'ArrowRight') {
        direction = null;
        isArrowKeyDown = false;
        storyWrapperElem.style.scrollBehavior = '';
    }
}

function arrowKeyMovement(timestamp) {
    if (arrowKeydownTimestamp == null) {
        arrowKeydownTimestamp = timestamp;
    }

    const elapsed = timestamp - arrowKeydownTimestamp; // Time elapsed between last rAF fire

    if (arrowKeydownPreviousTimestamp !== timestamp) {
        const stepCount = Math.min(0.1 * elapsed, 20); // Maximum scroll amount per frame
        if (direction === 'left') {
            storyWrapperElem.scrollLeft -= stepCount;
        } else if (direction === 'right') {
            storyWrapperElem.scrollLeft += stepCount;
        }
    }

    rafTicking = false;
    arrowKeydownPreviousTimestamp = timestamp;

    if (isArrowKeyDown == true) {
        requestArrowTick();
    }

    // if (direction === null && elapsed < 4000) {
    //     arrowKeydownPreviousTimestamp = timestamp;
    //     requestArrowTick();
    // }
}

const checkIfModalIsShowing = function () {
    const modelContainer = document.querySelector('.story__modal')
    if (modelContainer && modelContainer.classList.contains('show')) {
        return true
    } else {
        return false;
    }
}


// This function is used to calculate for both width (x) and height (y) axis
// Returns scrollProgress valye
const calculateStoryStoryAxisPosition = (viewportBounds, storyFullContentSize, scrollPos) => {
    if (storyFullContentSize == 0) {
        return 0
    }
    else {
        return Math.round(scrollPos / (storyFullContentSize - viewportBounds) * 100);
    }
}

const calculateStoryProgress = function () {
    let storyScrollProgress = 3;

    if (!isMobile) {
        const storyFullContentSize = document.querySelector('.stories__wrapper-inner').children[0].scrollWidth;
        storyScrollProgress = calculateStoryStoryAxisPosition(storyWrapperElem.clientWidth, storyFullContentSize, storyWrapperElem.scrollLeft);
    }
    else {
        const storyFullContentSize = document.querySelector('.stories__wrapper-inner').children[0].scrollHeight;
        storyScrollProgress = calculateStoryStoryAxisPosition(storyWrapperElem.clientHeight, storyFullContentSize, storyWrapperElem.scrollTop);
    }

    if (storyScrollProgress >= 3) {
        const storyProgressValueElem = document.querySelector('.story__progress__value');
        if (storyProgressValueElem) {
            storyProgressValueElem.style.width = storyScrollProgress + '%';
        }
    }
}

const checkScreensize = function () {
    return window.innerWidth < 768
}

const startDragging = function (event) {
    storyMouseDown = true;
    storyWrapperElem.classList.add('dragging');

    if (!isMobile) {
        storyMouseStartX = event.pageX - storyWrapperElem.offsetLeft;
        storyMouseScrollLeft = storyWrapperElem.scrollLeft;
    }
    else {
        storyMouseStartY = event.pageY - storyWrapperElem.offsetTop;
        storyMouseScrollTop = storyWrapperElem.scrollTop;
    }
}

const stopDragging = function (event) {
    storyMouseDown = false;
    storyWrapperElem.classList.remove('dragging');

    if (!isMobile) {
        storyMouseStartX = event.pageX - storyWrapperElem.offsetLeft;
    } else {
        storyMouseStartY = event.pageX - storyWrapperElem.offsetTop;
    }
}

const dragging = function (event) {
    event.preventDefault();
    if (!storyMouseDown) { return; }

    if (!isMobile) {
        const x = event.pageX - storyWrapperElem.offsetLeft;
        const scroll = x - storyMouseStartX;
        storyWrapperElem.scrollLeft = (storyMouseScrollLeft - scroll * 2.75);
    } else {
        const y = event.pageY - storyWrapperElem.offsetTop;
        const scroll = y - storyMouseStartX;
        storyWrapperElem.scrollLeft = (storyMouseScrollLeft - scroll * 1.5);
    }
}

const scrollStory = function (event) {
    if (checkIfModalIsShowing()  || storyDetailPageActive()) {
        event = window.event || event;
        const delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));

        if (!isMobile) {
            storyWrapperElem.scrollLeft -= (delta * scrollSpeed); // Multiplied by 40
        } else {
            storyWrapperElem.scrollTop -= (delta * scrollSpeed); // Multiplied by 40 
        }
    }
}

const initaliseModalEventListeners = function () {
    let isDragging = false;
    let isMouseDown = false;
    let wasDragging = false;
    const storyModels = document.querySelectorAll('.js-story-model');

    // Setup the event handling to check whether the mouse has been clicked and if it is dragging the carousel. If it is dragging we don't want to load the modal
    // If however, the user has clicked the item then we should allow it to be opened in the modal
    storyModels.forEach(storyModel => {
        storyModel.addEventListener('mousemove', e => {
            if (isMouseDown) {
                isDragging = true;
            }
        });

        storyModel.addEventListener('mousedown', e => {
            isMouseDown = true;
        });

        storyModel.addEventListener('mouseup', e => {
            if (isDragging) {
                wasDragging = true;
                isDragging = false;

                // reset wasDragging after a short time so the user can reclick again
                setTimeout(() => {
                    wasDragging = false;
                }, 500);
            }

            isMouseDown = false;
        });

        storyModel.addEventListener('click', event => {
            event.preventDefault();

            if (wasDragging === true) {
                isDragging = false;
            }
            else {
                document.querySelector("#storyModal").classList.remove("fade-out");
                const priorToModalURL = window.location.href;
                const href = event.target.closest('a').getAttribute('href');

                const { params } = extractStoriesParamsFromURL(href);

                document.querySelector("#storyModal").classList.remove("fade-out");

                loadStoryModal(window.preferredCulture, params.storyPageId);

                const url = new URL(href);
                const modalUrl = url.href;

                url.searchParams.delete('storyPageId');
                url.searchParams.delete('language');
                window.history.pushState({ originPriorToModal: priorToModalURL, modalUrl: modalUrl }, null, url.href);
            };
        });

        storyModel.addEventListener('keydown', event => {
            if (event.key) {
                enterKeyPressed = true;
                setTimeout(() => {
                    enterKeyPressed = false;
                },250);
            }
        });
    });

    $(".js-close-model").on("click", onModalClose);
}

const onModalClose = () => {
    const scrollContainer = $('#scroll-container').children();
    document.querySelector("#storyModal").classList.add("fade-out");

    // Unregister events
    document.removeEventListener('keydown', keyDownScrollingEvent);
    document.removeEventListener('keyup', keyUpScrollingEvent);

    setTimeout(() => {
        if (scrollContainer) {
            scrollContainer.each(index => {
                scrollContainer[index].classList.remove("visibility-none");
            });
        }

        $('#storyModal').modal('hide');

        const url = new URL(window.location);
        url.searchParams.delete('storyId');

        history.back();
        document.querySelector('.story__progress__value').style.width = 3 + '%';
        $('#storyModal').find('.stories__wrapper').remove();
    }, 1000);
}


window.addEventListener('popstate', (event) => {
    // If we have custom data in the history state, check for whether a stories url including params has been saved
    // if so we will want to extract the info and then go to it

    if (event.state && Object.keys(event.state).includes('modalUrl')) {
        // Open story modal
        const { params } = extractStoriesParamsFromURL(event.state.modalUrl);

        document.querySelector("#storyModal").classList.remove("fade-out");
        loadStoryModal(window.preferredCulture, params.storyPageId);
    } else {
        // Close any story modals if they exist
        if ($('#storyModal')) {
            $('#storyModal').modal('hide');
        }
    }
})

const loadStoryModal = function (language, storyPageId) {
    $('#storyModal').modal({
        show: false,
        focus: true,
        keyboard: true,
    });

    loadStoryContent(language, storyPageId);
}

function runImageAnimation4seconds(image) {
    var paths = image.querySelectorAll('path');
    paths.forEach(path => {
        var length = path.getTotalLength();
        // Clear any previous transition
        path.style.transition = path.style.WebkitTransition = 'none';
        // Set up the starting positions
        path.style.strokeDasharray = length + ' ' + length;
        path.style.strokeDashoffset = length;
        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        path.getBoundingClientRect();
        // Define our transition
        //path.style.transition = path.style.WebkitTransition = 'opacity 0.25s ease-in-out';
        path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 4s ease-in-out';
        // Go!
        path.style.strokeDashoffset = '0';
    });
}
function runImageAnimation2seconds(image) {
    var paths = image.querySelectorAll('path');
    paths.forEach(path => {
        var length = path.getTotalLength();
        // Clear any previous transition
        path.style.transition = path.style.WebkitTransition = 'none';
        // Set up the starting positions
        path.style.strokeDasharray = length + ' ' + length;
        path.style.strokeDashoffset = length;
        // Trigger a layout so styles are calculated & the browser
        // picks up the starting position before animating
        path.getBoundingClientRect();
        // Define our transition
        //path.style.transition = path.style.WebkitTransition = 'opacity 0.25s ease-in-out';
        path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out';
        // Go!
        path.style.strokeDashoffset = '0';
    });
}

function runIntersectionObserver(images) {

    const options = {
        rootMargin: '0px',
        threshold: 0.25
    }

    let observer = new IntersectionObserver((entries) => {

        entries.forEach(image => {
            var svg2s = image.target.querySelector('.squiggle2s');

            if (svg2s) {
                if (Object.entries(svg2s) != null && image.intersectionRatio > 0.15) {
                    svg2s.style.opacity = "1";
                    runImageAnimation2seconds(image.target);
                    observer.unobserve(image.target);
                }
            }

            var svg4s = image.target.querySelector('.squiggle4s');
            if (svg4s) {

                if (Object.entries(svg4s) != null && image.intersectionRatio > 0.15) {
                    svg4s.style.opacity = "1";
                    runImageAnimation4seconds(image.target);
                    observer.unobserve(image.target);
                }

            }
        })
    }, options)

    images.forEach(image => {
        observer.observe(image);
    })
}

const loadStoryContent = function (language, storyPageId) {
    const url = '/pageapi/stories/?storyPageId=' + storyPageId + '&language=' + language
    axios.get(url).then(response => {
        $('#storyModal .modal-content').append(response.data);

        storyProgressInit();
        calculateStoryProgress();
        //horizontalSmoothScrolling();
        $('#storyModal').modal('show');
        document.body.classList.add('story-modal-open');

        document.querySelector('#storyModal')?.removeAttribute('tabindex');

        if (enterKeyPressed) {
            $(".js-close-model").focus();
        }

        setupFocusCatchingInModalContent(storyModalElem);

        const lineAnimation = document.querySelectorAll('.anim');
        runIntersectionObserver(lineAnimation);

    }).catch(error => {
        console.error(error);
    });
}

const setupFocusCatchingInModalContent = (container) => {
    const focusable = getAllFocusableElementsWithinElement(container);
    const storiesWrapper = document.querySelector('.stories__wrapper');
    let tabPressed = false;

    if (!focusable) {
        return;
    }

    window.addEventListener('keydown', function (keyEvent) {
        if (keyEvent.code == "Tab") {
            tabPressed = true;
            setTimeout(() => {
                tabPressed = false;
            }, 250);
        } else {
            tabPressed = false;
        }

        const firstFocusableEl = focusable[0];
        const lastFocusableEl = focusable[focusable.length - 1];

        const isTabPressed = (keyEvent.key === 'Tab' || keyEvent.keyCode === 9);
        if (isTabPressed) {
            if (keyEvent.shiftKey) { // Shift + Tab
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    keyEvent.preventDefault();
                }
            } else { // Tab
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    keyEvent.preventDefault();
                }
            }
        }
    });

    focusable.forEach(elem => {
        if (elem.classList.contains('js-close-model')) {
            return;
        }
        
        elem.addEventListener('focus', (elemEvent) => {
            if (tabPressed && elemEvent.target === elem) {
                if (!storiesWrapper) {
                    return;
                }
                const elemLeftPos = elemEvent.target.getBoundingClientRect().left;
                const elemHalfWidth = elemEvent.target.offsetWidth / 2;
                const elementCenterScrollPos = (storiesWrapper.scrollLeft + (elemLeftPos + elemHalfWidth)) - (window.innerWidth / 2)

                storiesWrapper.scrollLeft = elementCenterScrollPos;
            }
        });
    });
}

// const horizontalSmoothScrolling = function () {

//     window['scrolInstance'].destroy();
//     const scroller = document.getElementById('stories-scroller')

//     let locoScroll = new LocomotiveScroll({
//         el: scroller,
//         smooth: true,
//         direction: "horizontal",
//         smartphone: {
//             smooth: true,
//             direction: "vertical",
//         },
//         tablet: {
//             smooth: true,
//             direction: "horizontal",
//         }
//     });

//     locoScroll.update();
//     window['ScrolInstanceModal'] = locoScroll;
// }


